import { useTheme } from 'styled-components';
import { Button } from '../../ui/Button/Button';
import { ThemeType } from '../../../theme/themeType';
import S from './ConfirmModalStyles';

type Props = {
  title: string;
  btnConfirmText?: string;
  btnConfirmBackgroundColor?: string;
  btnConfirmTextColor?: string;
  onClose: () => void;
  onConfirm: () => void;
};

function ConfirmModal({
  title,
  btnConfirmText = 'Confirm',
  btnConfirmBackgroundColor,
  btnConfirmTextColor,
  onClose,
  onConfirm,
} : Props): JSX.Element {
  const theme = useTheme() as ThemeType;
  return (
    <S.Wrapper>
      <div className="title">
        {title}
      </div>
      <div className="actions">
        <Button
          className="button"
          padding="7px 40px"
          onClick={onClose}
        >Cancel
        </Button>
        <Button
          className="button"
          padding="7px 40px"
          onClick={onConfirm}
          background={btnConfirmBackgroundColor ?? theme.colors.green}
          textColor={btnConfirmTextColor ?? theme.colors.black}
        >{btnConfirmText}
        </Button>
      </div>
    </S.Wrapper>
  );
}

export default ConfirmModal;
